const toOptionalString = (value: string | undefined | null): string | undefined => {
  return value || undefined;
};

const toOptionalNumber = (value: string | undefined | null): number | undefined => {
  if (!value) return undefined;
  const n = Number(value);
  return Number.isNaN(n) ? undefined : n;
};

export { toOptionalString, toOptionalNumber };
